const numberToText = ['mindre än en', 'en', 'två', 'tre', 'fyra', 'fem'];
export const minutesAmount = (minutes: number) => numberToText.at(minutes) || minutes;

/**
 * Determines the correct Swedish plural form for minutes.
 *
 * @param minutes - The number of minutes to format
 * @returns 'minut' for singular (1 minute or numbers ending in 1 after 11), 'minuter' for plural
 */
export const minuteText = (minutes: number) =>
  minutes < 2 || (minutes > 11 && minutes % 10 === 1) ? 'minut' : 'minuter';
